export async function renderAnimatedText({
	container,
	text,
	addToGlobalCells = true,
	cellTemplate,
	shapeForChar,
	getShapeFrames,
	shuffleArray,
	inlineCells,
}) {
	if (!cellTemplate) {
		console.error('Cell template not found');
		return;
	}

	const existingCells = container.querySelectorAll('.artist-cell');
	if (existingCells.length > 0) {
		const localCells = [];
		const usedShapes = new Set();
		existingCells.forEach((cell) => {
			const char = cell.dataset.char || '';
			if (char.trim()) {
				usedShapes.add(shapeForChar(char));
			}
		});

		try {
			await Promise.all([...usedShapes].map((shape) => getShapeFrames(shape)));
		} catch (error) {
			console.error('Failed to load frames:', error);
			return;
		}

		await Promise.all(
			[...existingCells].map(async (cell) => {
				const char = cell.dataset.char || '';
				const pathEl = cell.querySelector('path');
				if (!pathEl || !char.trim()) {
					return;
				}
				const shape = shapeForChar(char);
				const cachedFrames = await getShapeFrames(shape);
				const frames = shuffleArray(cachedFrames);
				pathEl.setAttribute('d', frames[0] || '');
				localCells.push({ pathEl, frames, frameIndex: 0 });
			})
		);

		if (addToGlobalCells) {
			inlineCells.push(...localCells);
		}
		return;
	}

	const chars = [...text];
	const usedShapes = new Set();
	for (const char of chars) {
		if (char.trim()) {
			usedShapes.add(shapeForChar(char));
		}
	}

	try {
		await Promise.all([...usedShapes].map((shape) => getShapeFrames(shape)));
	} catch (error) {
		console.error('Failed to load frames:', error);
		return;
	}

	container.innerHTML = '';
	const localCells = [];
	const words = text.split(/\s+/).filter((word) => word.length > 0);

	for (let wordIndex = 0; wordIndex < words.length; wordIndex += 1) {
		const word = words[wordIndex];
		const wordContainer = document.createElement('span');
		wordContainer.className = 'animate-word';

		for (const char of word) {
			const node = cellTemplate.content.firstElementChild.cloneNode(true);
			const pathEl = node.querySelector('path');
			const labelEl = node.querySelector('.artist-cell-label');
			const shape = shapeForChar(char);
			const cachedFrames = await getShapeFrames(shape);
			const frames = shuffleArray(cachedFrames);

			pathEl.setAttribute('d', frames[0] || '');
			labelEl.textContent = char.toUpperCase();
			wordContainer.appendChild(node);
			localCells.push({ pathEl, frames, frameIndex: 0 });
		}

		container.appendChild(wordContainer);
		if (wordIndex < words.length - 1) {
			const spacer = document.createElement('span');
			spacer.className = 'animate-space';
			spacer.setAttribute('aria-hidden', 'true');
			container.appendChild(spacer);
		}
	}

	if (addToGlobalCells) {
		inlineCells.push(...localCells);
	}
}

export async function initInlineAnimatedText({
	cellTemplate,
	renderAnimatedTextImpl,
}) {
	if (!cellTemplate) {
		console.warn('Cell template not available - inline animated text disabled');
		return;
	}

	const inlineElements = document.querySelectorAll('[data-animate-text]');
	for (const element of inlineElements) {
		const text = element.getAttribute('data-animate-text');
		if (text) {
			await renderAnimatedTextImpl(element, text, true);
		}
	}
}
